// removed by extract-text-webpack-plugin
module.exports = {"base":"_1pxLp","default":"_3WhPd _1pxLp","em":"_3Bd4g _1pxLp","strong":"_2r4M6 _1pxLp","remsa":"_1PKYK _1pxLp","green":"_2dhF8 _1pxLp","spoiler":"_3Ddk4 _1pxLp","tid":"LGbZO","marginal":"_1DAxb","kula":"K4Dqc","red":"_2_NgR","blue":"LY_Sn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/StyledText/StyledTextComponents/Styled.scss
 ** module id = 430
 ** module chunks = 0
 **/